// src/components/Gallery.js
import React from 'react';
import styles from './Gallery.module.css';

// Update with your actual images and info
const images = [
  {src: "/Director.jpg", name: "Director"},
  {src: "/headteacher.jpg", name: "Headteacher"},
  {src: "/Staff1.jpg", name: ""},
  {src: "/Staff2.jpg", name: ""},
  {src: "/Staff3.jpg", name: ""},
  {src: "/Staff4.jpg", name: ""},
  {src: "/Staff5.jpg", name: ""},
  {src: "/1.jpg", name: ""},
  {src: "/3.jpg", name: ""},
  {src: "/4.jpg", name: ""},
  {src: "/6.jpg", name: ""}, 
  {src: "/7.jpg", name: ""},
  {src: "/8.jpg", name: "  "},
  {src: "/9.jpg", name: " "},  
  {src: "/10.jpg", name: " "},
  {src: "/11.jpg", name: " "},
  {src: "/12.jpg", name: " "},
  {src: "/13.jpg", name: " "},
  {src: "/14.jpg", name: " "},
  {src: "/15.jpg", name: " "},
  {src: "/16.jpg", name: " "},
  {src: "/17.jpg", name: " "},
  {src: "/18.jpg", name: " "},
  {src: "/20.jpg", name: " "},
  {src: "/21.jpg", name: " "},
  {src: "/22.jpg", name: " "},
  {src: "/24.jpg", name: " "},
  {src: "/25.jpg", name: " "},
  {src: "/26.jpg", name: " "},
  {src: "/27.jpg", name: " "},
  {src: "/28.jpg", name: " "},
  {src: "/29.jpg", name: " "},
  {src: "/30.jpg", name: " "},
  {src: "/31.jpg", name: " "},
  {src: "/32.jpg", name: " "},
  {src: "/33.jpg", name: " "},
  {src: "/Staff6.jpg", name: " "},
  {src: "/Staff7.jpg", name: " "},
  {src: "/Staff8.jpg", name: " "},
  {src: "/Staff9.jpg", name: " "},
  {src: "/Staff10.jpg", name: ""},
  {src: "/Staff11.jpg", name: ""},
  {src: "/Staff12.jpg", name: ""},
  
  
  // Ongezea zingine hapa !//
];

function Gallery() {
  return (
    <section className={styles.gallerySection}>
      <h2>Gallery: Our Staff & Students</h2>
      <div className={styles.grid}>
        {images.map((img, idx) => (
          <div className={styles.card} key={idx}>
            <img src={img.src} alt={img.name} className={styles.img} />
            <div className={styles.caption}>{img.name}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Gallery;
